import React from "react";

// MUI Imports
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

const ReportHistoryHeader = () => {
  const headCells = [
    { id: "Report Type", numeric: false, label: "Report Type" },
    { id: "Report Information", numeric: false, label: "Report Information" },
    { id: "Report Token", numeric: false, label: "Report Token" },
  ];

  return (
    <TableHead>
      <TableRow className="header">
        {headCells.map(({label, id}) => (
          <TableCell
            key={id}
            className="headerText"
            align="center"
            padding="normal"
          >
            {label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default ReportHistoryHeader;
